import { render } from "./PointPlanForm.vue?vue&type=template&id=c2ae7c58&scoped=true"
import script from "./PointPlanForm.vue?vue&type=script&lang=js"
export * from "./PointPlanForm.vue?vue&type=script&lang=js"

import "./PointPlanForm.vue?vue&type=style&index=0&id=c2ae7c58&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ae7c58"]])

export default __exports__